import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3547 4.01162L14.5 8H20C21.6569 8 23 9.34315 23 11V14.0557C23 14.6767 22.8554 15.2892 22.5777 15.8446L20.8292 19.3416C20.321 20.358 19.2822 21 18.1459 21H4C2.89543 21 2 20.1046 2 19V11C2 9.89543 2.89543 9 4 9H7L11.5124 1.78017C11.8157 1.29484 12.3477 1 12.92 1C14.5052 1 15.6868 2.46162 15.3547 4.01162ZM7 10.5H4C3.72386 10.5 3.5 10.7239 3.5 11V19C3.5 19.2761 3.72386 19.5 4 19.5H7V10.5ZM19.4875 18.6708C19.2335 19.179 18.7141 19.5 18.1459 19.5H8.5V9.4302L12.7844 2.57517C12.8136 2.52841 12.8649 2.5 12.92 2.5C13.5502 2.5 14.02 3.08109 13.888 3.69732L13.0333 7.68571C12.9384 8.12864 13.0487 8.59074 13.3335 8.94302C13.6183 9.29529 14.047 9.5 14.5 9.5H20C20.8284 9.5 21.5 10.1716 21.5 11V14.0557C21.5 14.4438 21.4096 14.8266 21.2361 15.1738L19.4875 18.6708Z"
        fill="#4E406E"
      />
    </g>
  </svg>
);
export default SVGComponent;
